export default __webpack_public_path__ + "static/media/Images-03.d6e3263d.png";